import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from 'src/app/core/api/api.service';
import { QUALIFICATION_ENDPOINTS } from 'src/app/core/api/endpoints/qualification.endpoints';

@Injectable({
  providedIn: 'root',
})
export class QualificationService {
  private api = inject(ApiService);

  getQualificationStatus(): Observable<any> {
    return this.api.get(QUALIFICATION_ENDPOINTS.V1.QUALIFICATION_STATUS).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }
  listQualifiersActions(): Observable<any> {
    return this.api.get(QUALIFICATION_ENDPOINTS.V1.INSPECTOR_COMMANDS).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  ApplyQualifiersActions(query, inspectors): Observable<any> {
    return this.api.post(
      QUALIFICATION_ENDPOINTS.V1.INSPECTOR_EXECUTE_COMMAND,
      inspectors,
      {
        params: { command: query },
      },
    );
  }
  
  handleError(error) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
